import { render, staticRenderFns } from "./ViewPrivacy.vue?vue&type=template&id=785e6adb&scoped=true"
import script from "./ViewPrivacy.vue?vue&type=script&lang=js"
export * from "./ViewPrivacy.vue?vue&type=script&lang=js"
import style0 from "./ViewPrivacy.vue?vue&type=style&index=0&id=785e6adb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "785e6adb",
  null
  
)

export default component.exports